import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import HighchartsExportData from 'highcharts/modules/export-data';
import HighchartsExporting from 'highcharts/modules/exporting';
import variablePie from 'highcharts/modules/variable-pie.js';
import { ForwardedRef, forwardRef } from 'react';
import { graphColorPalette } from '../constants';
import { PieChartData } from '../types';

if (typeof Highcharts === 'object') {
  variablePie(Highcharts);
  HighchartsExporting(Highcharts);
  HighchartsExportData(Highcharts);
}

export const CampaignAnalyticsPieChart = forwardRef(
  ({ data }: { data: PieChartData }, ref: ForwardedRef<HighchartsReact>) => {
    const options: Highcharts.Options = {
      chart: {
        type: 'variablepie',
      },
      credits: {
        enabled: false,
      },
      title: {
        text: undefined,
      },
      exporting: { enabled: false },
      plotOptions: {
        variablepie: {
          colors: graphColorPalette,
        },
      },
      tooltip: {
        enabled: true,
        pointFormat: '<b>{point.y}</b>',
      },
      series: [
        {
          type: 'variablepie',
          minPointSize: 10,
          innerSize: '40%',
          dataLabels: {
            enabled: true,
            format: `<span>{point.name}</span><br/><span>{point.percentage:.1f}%</span>`,
          },
          data,
        },
      ],
    };

    return <HighchartsReact highcharts={Highcharts} options={options} ref={ref} />;
  },
);
